import Indicador from "./Indicador";

export class IndicadorMeta{
    id: number | null;
    meta: number | null;
    tipo: string | null;
    dataInicio: Date | null;
    dataFim: Date | null;
    indicador: Indicador | null;

    constructor(
        id = 0,
        meta = 0,
        tipo = '',
        dataInicio: Date | null = null,
        dataFim: Date | null = null,
        indicador = null
    ){
        this.id = id;
        this.meta = meta;
        this.tipo = tipo;
        this.dataInicio = dataInicio;
        this.dataFim = dataFim;
        this.indicador = indicador;
    }
}